// extracted by mini-css-extract-plugin
export default {"generalBoschFont":"\"boschsans\",sans-serif !important"};